import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export function EmptyState({
  icon: Icon,
  title,
  children,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-2 px-6 py-10 text-center", className)}>
      {Icon ? (
        <div className="mb-1 grid size-10 place-items-center rounded-full bg-surface-2 text-subtle">
          <Icon className="size-5" />
        </div>
      ) : null}
      <p className="text-sm font-medium text-fg">{title}</p>
      {children ? <div className="max-w-sm text-xs text-muted">{children}</div> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}

/** For a failed query: the message and a retry button. */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message = error instanceof Error ? error.message : "Something went wrong";
  return (
    <div role="alert" className="flex flex-col items-center gap-2 px-6 py-10 text-center">
      <p className="text-sm font-medium text-down">Couldn't load this</p>
      <p className="max-w-sm text-xs text-muted">{message}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} className="mt-1 text-xs font-medium text-brand hover:underline">
          Try again
        </button>
      ) : null}
    </div>
  );
}
